export default "__VITE_ASSET__O6s230y1__"